<template>  
  <div class="wrapper">
   <h2>speakers at the conference</h2>
   <div class="one-section">
    <div class="img">
     <img :src="photos.daniel" alt="">
     <h3>Daniel  Satchkov</h3>
     <h5> <i>President of RiXtrema Inc. </i> </h5>
    </div>
    <div class="bio">     
     <p>
      Daniel Satchkov (MBA,CFA) is President of RiXtrema, which specializes in risk modeling, and consulting for extreme market events. They design and build customized risk models for the investment sector, and crash test portfolios for financial professionals. As Associate Director of Risk Research at FactSet, Daniel worked on innovative software products involving risk measurement and reporting. He is in demand as a conference speaker and published widely in leading industry magazines including the Journal of Asset Management and IPE. In 2015 he received the prestigious Peter L. Bernstein Award.
     </p>
    </div>
   </div>
   <div class="one-section reverse">
    <div class="img">
     <img :src="photos.yon" alt="">
     <h3>Yon Perullo</h3>
     <h5> <i>CEO of RiXtrema Inc. </i> </h5>
    </div>
    <div class="bio">
     
     <p>
       Yon Perullo is the CEO of RiXtrema. His career started in fintech at FactSet Research Systems where he was head of quantitative analytics and charged with directing the global sales and development of FactSet’s suite of quantitative products, including alpha modeling, portfolio simulation, and risk analysis.
       In between tech stints, Yon had several institutional asset management roles. As an allocator he served as the Chief Investment Strategist for the public market investments of Tresalia Asset Management a multi-billion dollar Mexico City based family office, and the Chief Risk Officer and Director of Asset Allocation for Fiduciary Research, a $10Bn outsourced CIO where he focused on designing and implementing the asset allocation, risk management and hedging programs for defined benefit and nuclear decommissioning trust assets.
       Yon has also been a portfolio and risk manager for hedge funds and mutual funds, running strategies at Guggenheim Investments focusing on long only and long short global equity, and at Nascent Strategies where he ran a market neutral equity portfolio.
     </p>
    </div>
   </div>  
   <div class="one-section ">
    <div class="img">
     <img :src="photos.yaakov" alt="">
     <h3>Yaacov Kopeliovich</h3>
     <h5> <i> Associate Professor in Residence</i> </h5>
    </div>
    <div class="bio">
     
     <p>
       Yaacov Kopeliovich has been an Associate Professor in Residence in Finance department at the University of Connecticut (UConn) business school since 2015. He teaches a Financial Modeling Risk Course in the UConn FRM program. 
       Prior to teaching, Yaacov was the director of Research at Rixtrema where he worked with asset managers across the globe to implement robust risk management processes. He also developed RiXtrema’s Fixed Income modeling engine and was instrumental in developing the Option Risk engine.
       Yaacov started his financial career in 2006 working in MEAG NY an asset manager for Munich Re at the quant desk specializing in Fixed Income investments .
       Prior to 2006 Yaacov was a Post Doctorate Researcher in Mathematics. Yaacov also served in the Israeli Military and has a rank of lieutenant.
       Yaacov holds a PH.D. in Mathematics from the Hebrew University of Jerusalem (1995) and a Ph.D. in Finance from EDHEC school of Business (2014).
     </p>
    </div>
   </div>    
  </div>
</template>

<script>
export default {
 name: 'Bio',
 data: function(){
  return {
   photos:{
    daniel: require('./danielsatch-min.jpg'),
    yon: require('./yonperullo-min.jpg'),
    yaakov: require('./yaakov.png'),
   }
  }
 }
}
</script>

<style lang="scss">
.wrapper {

  margin-top: 40px;
  // text-align: center;
  // padding: 10px 0;
  // border-top: 2px solid rgb(197, 194, 194);
  // border-bottom: 2px solid rgb(197, 194, 194);
  h2{
   font-size: 3em;
   text-align: center;
   text-transform: uppercase;
  }
  .reverse{
    display: flex;
    flex-direction: row-reverse !important;
   }
  .one-section{
   display: flex;
   flex-wrap: wrap;
   margin: 30px 0;
   border-top: 2px solid rgb(197, 194, 194);
   border-bottom: 2px solid rgb(197, 194, 194);
   

   .img{
    margin: 0 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img{
     margin: 20px 0;
     border-radius: 50%;
     width: 200px;
    }
    h3{
     font-weight: 600;
     font-size: 2.5em;
     margin: 20px 0;
     text-align: center;
    }
    h5{
     font-size: 1.5em;
     text-align: center;
     margin-bottom: 15px;
    }
   }

   .bio{
    width: 60%;
    margin: 0 40px;
    display: flex;
    justify-content: center;
    
    
    p{
     font-size: 1.8em;
     margin: 20px 0;
    }

   }
   @media only screen and (max-width: 800px) {
    font-size: 1.5em;
    width: 100%;
    .bio{
      width: 100%;
    }
    .img{
      width: 100%;
    }

  }
  }
}
</style>
